export default __webpack_public_path__ + "static/media/17.d81660f3.jpg";